import { render } from "./App.vue?vue&type=template&id=41fd576c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=41fd576c&lang=css"

import exportComponent from "D:\\DEV\\STATIC\\player-speakup\\player\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__